












































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import { YKDRightDrawer } from 'gum-ui'
import { queryMytopicGroup } from '@/api/exam/myTopicGroup'
import MyTopicGroup from '@/model/exam/myTopicGroup'
import { QueryMyTopicGroupParam } from '@/api/exam/myTopicGroup'
import moment from 'moment'

@Component({
  components: {
    YKDRightDrawer
  }
})
export default class EmployeeHistory extends Vue {
  @Prop() private topicGroupId?: string
  @Prop() private accountId?: string
  @Prop() private visible?: boolean
  @Prop() private companyId?: string

  private queryMytopicGroupParam?: QueryMyTopicGroupParam = {}
  private myTopicGroups: MyTopicGroup[] = []

  openHistory() {
    this.$emit('open')
  }

  close() {
    this.$emit('close')
  }
  confirm() {
    this.$emit('close')
  }
  //计算答题耗时
  calculateTime(startTime: string, endTime: string) {
    new Date(startTime).getTime() - new Date(endTime).getTime()
  }
  @Watch('topicGroupId')
  async intnData() {
    //查询考试记录
    this.queryMytopicGroupParam = {
      topicGroupIds: [this.topicGroupId!],
      accountIds: [this.accountId!],
      companyId: this.companyId,
      pagination: 0,
      pageSize: 50
    }
    const data = await queryMytopicGroup(this.queryMytopicGroupParam)
    this.myTopicGroups = data.data!
    this.myTopicGroups.sort((a: MyTopicGroup, b: MyTopicGroup) => {
      if (moment(a.endTime) > moment(b.endTime)) {
        return -1
      }
      return 1
    })
    console.log(this.myTopicGroups, 'qqqqq')
  }
  getScore(useTime: any) {
    if (Math.round((useTime || 0) / 60) <= 0) {
      return 1
    } else {
      return Math.round((useTime || 0) / 60)
    }
  }
  @Watch('accountId')
  async intnDate2() {
    console.log('qqq')
    //查询考试记录
    this.queryMytopicGroupParam = {
      topicGroupIds: [this.topicGroupId!],
      accountIds: [this.accountId!],
      companyId: this.companyId,
      pagination: 0,
      pageSize: 50
    }
    const data = await queryMytopicGroup(this.queryMytopicGroupParam)
    this.myTopicGroups = data.data!
    this.myTopicGroups.sort((a: MyTopicGroup, b: MyTopicGroup) => {
      if (moment(a.endTime) > moment(b.endTime)) {
        return -1
      }
      return 1
    })
    console.log(this.myTopicGroups, 'qqqqq')
  }
}
